<template>
    <div>
        <progress-header />

        <search-form :tracking-name="trackingName" @search="search" />

        <search-tips type="airport_transfers" />
    </div>
</template>

<script>
    import SearchForm from './components/SearchForm';
    import SearchTips from '@components/SearchTips';
    import ProgressHeader from './components/ProgressHeader';
    import {trackGA} from '@utilities/tracking';

    export default {
        components: {
            SearchForm,
            SearchTips,
            ProgressHeader,
        },

        data() {
            return {
                trackingName: 'Przejazdy liniowe',
            };
        },

        created() {
            trackGA('view_item', {
                'items': [
                    {
                        id: window.location.pathname,
                        name: this.trackingName,
                        quantity: 1,
                    },
                ],
            });
            trackGA('checkout_progress', {
                checkout_step: 1,
                checkout_option: window.location.pathname,
            });
        },

        methods: {
            search(data) {
                this.$store.dispatch('airportTransfersSearch/reset').then(() => {
                    this.$store.dispatch('airportTransfersSearch/setSearchParameters', data).then(() => {
                        this.$store.dispatch('airportTransfersSearch/setPassengersNumber', data.passengers_number).then(() => {
                            this.$router.push({name: 'airport-transfers.search'});
                        });
                    });
                });
            },
        },
    };
</script>
